module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu7GxKOzY.718dded3.woff2";